import MyExpApi from "../../enum/MyExpApi";
import { useGetApiData } from "shared/datalayer";
import ApiEnabledFeatures from "shared/types/ApiEnabledFeatures";

export function useGetEnabledFeaturesDetails({ registrationParticipantId }: { registrationParticipantId?: string }) {
  return useGetApiData<Array<ApiEnabledFeatures>>(
    MyExpApi.REGISTRATION_GET_ENABLED_FEATURE,
    {
      params: { id: registrationParticipantId }
    },
    {
      enabled: Boolean(registrationParticipantId)
    }
  );
}
